import { FC, memo } from 'react'

import { AccommodationItemTransport } from '../../../transports/region-landing-page-transport'
import { getBasePath } from '../../../utils/miscellaneous-utils'
import {
    ItemLink,
    ItemInnerContainer,
    ImageWrapper,
    Image,
    InfoContainer,
    NameContainer,
    Accommodation,
} from './styles'

const _getHolidayIdeaImage = (id: AccommodationItemTransport['id']) => {
    const basePath = `/assets/images/holiday-ideas/${id}.jpg`
    return getBasePath(`${basePath}?imwidth=200`)
}

interface HolidayIdeaListItemProps {
    item: AccommodationItemTransport
    index: number
}

const HolidayIdeaListItem: FC<HolidayIdeaListItemProps> = ({ item, index }) => (
    <ItemLink href={item.link} title={item.linkTitle} data-index={index}>
        <ItemInnerContainer>
            <ImageWrapper>
                <Image
                    src={_getHolidayIdeaImage(item.id)}
                    alt={item.linkTitle}
                    loading="lazy"
                    decoding="async"
                    fetchPriority="low"
                />
            </ImageWrapper>
            <InfoContainer>
                <NameContainer>{item.title}</NameContainer>
                {!!item.subtitle && <Accommodation>{item.subtitle}</Accommodation>}
            </InfoContainer>
        </ItemInnerContainer>
    </ItemLink>
)

export default memo(HolidayIdeaListItem)
